export const getDocsUrl = (ruleName: string): string =>
  `https://tanstack.com/router/latest/docs/eslint/${ruleName}`
